'use client';

import { FaDollarSign } from 'react-icons/fa';
import LicenceTypes from '@/components/report-page/buyNow/licencetype';
import PaymentMethods from '@/components/report-page/buyNow/payment-icons';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import ppt_icon from '../../../../public/PPT_icon.png';
import xcel_icon from '../../../../public/excel_icon.png';
import pdf_icon from '../../../../public/pdf_icon.png';
import BuyNowForm from '@/components/report-page/buyNow/buy-now-form';
import { ReportContext } from '@/app/providers/reportProvider';
import { useContext } from 'react';
import titleTumbnail from '../../../../public/reporttitle-thumbnils.webp';
import BuyNowCredibility from './buyNow-credibility';
import Clientel from '../../../../public/payment/existing-clientele-buynow.webp';
import { getCountries } from '@/app/utils/fetchdata';
import { useLocale, useTranslations } from 'next-intl';
import { Converter } from 'easy-currencies';

export default function BuyNow() {
  const [orderAmount, setOrderAmount] = useState('');
  const [licenceType, setLicenceType] = useState('');
  const [countryList, setCountryList] = useState([]);

  const report = useContext(ReportContext);
  const regionalText_1 = useTranslations('request_sample.get_instant_acc');
  const regionalText_2 = useTranslations('buyNow');
  const converter = new Converter();
  const locale = useLocale();

  const [licences, setLicences] = useState({
    SUL: report.Price_SUL,
    Multi: report.Price_Multi,
    CUL: report.Price_CUL,
  });

  useEffect(() => {
    const amt = localStorage.getItem('orderAmount');
    if (amt) {
      setOrderAmount(parseInt(amt.replace(',', '')));
      localStorage.removeItem('orderAmount');
    }
  }, []);

  //Effect to update the licenceType according to orderAmount
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });

    if (orderAmount === report.Price_SUL) {
      setLicenceType(regionalText_1('license_type.SUL'));
    } else if (orderAmount === report.Price_Multi) {
      setLicenceType(regionalText_1('license_type.MUL'));
    } else if (orderAmount === report.Price_CUL) {
      setLicenceType(regionalText_1('license_type.CUL'));
    } else if (orderAmount === 2000) {
      setLicenceType(regionalText_1('license_type.excel_databook'));
    }
  }, [orderAmount, report, regionalText_1]);

  //Effect to update the User Details for the sessionstorage
  useEffect(() => {
    sessionStorage.setItem('keyword', report.keyword);
    sessionStorage.setItem('licenceType', licenceType);
    sessionStorage.setItem('orderAmount', orderAmount);
  }, [orderAmount, licenceType, report]);

  //Fetching Countries
  useEffect(() => {
    async function fetchData() {
      const data = await getCountries();
      setCountryList(data);
    }
    fetchData();
  }, []);

  // useEffect(() => {
  //   async function getRegionalCurrency() {
  //     const to = locale === 'ja' ? 'JPY' : 'KRW';
  //     const sul = await converter.convert(report.Price_SUL, 'USD', to);
  //     const multi = await converter.convert(report.Price_Multi, 'USD', to);
  //     const cul = await converter.convert(report.Price_CUL, 'USD', to);
  //     console.log(sul.toLocaleString('ko'));
  //     console.log(multi.toLocaleString('ko'));
  //     console.log(cul.toLocaleString('ko'));
  //     // setOrderAmount(newAmt);
  //   }
  //   // if (locale != 'en') {
  //   getRegionalCurrency();
  //   // }
  // }, [orderAmount]);

  const FirstSection = () => {
    return (
      <section className="license-sec bg-blue-900">
        <div className="w-full p-5">
          <div className="px-5 py-10 rounded-md shadow-lg h-auto bg-white">
            <div className="report-heading mx-auto">
              {report.keyword === '' ? (
                <div className="flex flex-col gap-y-2 items-center justify-center">
                  <div className="h-5 bg-slate-400 w-full rounded" />
                  <div className="h-5 bg-slate-400 w-1/4 rounded" />
                </div>
              ) : (
                <div className="report-title font-bold text-lg text-blue-900 flex flex-row justify-items-start">
                  <Image
                    src={titleTumbnail}
                    alt="ppt_icon.png"
                    className="hidden lg:block"
                    height={25}
                    width={80}
                  />
                  <p className="ms-2">{report.newsSubject}</p>
                </div>
              )}
            </div>
            <div className="select-licence">
              <div className="my-4">
                <hr />
                {/* <SalesBanner className="mx-auto mt-2" /> */}
                <h1 className="selectType-heading mt-3">
                  {regionalText_1('heading')}
                </h1>
              </div>
              <div className="select-licence-col">
                <div className="grid lg:grid-cols-4 grid-cols-1 gap-y-5 lg:gap-x-5 ">
                  <div>
                    <div className="license-box license-box-first h-full ">
                      <p className="license-type flex justify-center items-center">
                        {regionalText_1('license_type.excel_databook')}
                      </p>

                      <p className="licence-price mt-10">
                        US
                        <FaDollarSign className="-mt-1 inline" /> 2,200
                      </p>
                      <p className="licence-price-text">
                        {regionalText_1('price_in_words.prc_1')}
                      </p>
                      <div className="text-center">
                        <button
                          onClick={() => {
                            setOrderAmount(2000);
                          }}
                          className="licence-buy-now cursor-pointer"
                          title="Buy Now"
                        >
                          {regionalText_1('buy_btn')}
                        </button>
                      </div>
                      <ul>
                        <li>{regionalText_1('descs.excel_databook.l1')}</li>
                        <li>{regionalText_1('descs.excel_databook.l2')}</li>
                        <li>{regionalText_1('descs.excel_databook.l3')}</li>
                        <li>{regionalText_1('descs.excel_databook.l4')}</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="license-box license-box-first h-full ">
                      <p className="license-type flex justify-center items-center">
                        {regionalText_1('license_type.SUL')}
                      </p>
                      <p className="text-center text-sm text-slate-600 font-normal my-1">
                        ({regionalText_1('full_report')})
                      </p>
                      <p className="licence-price-revise">
                        <del>US$ 4,500</del>
                      </p>
                      <p className="licence-price">
                        US
                        <FaDollarSign className="-mt-1 inline" />{' '}
                        {report.Price_SUL.toLocaleString()}
                      </p>
                      <p className="licence-price-text">
                        {regionalText_1('price_in_words.prc_2')}
                      </p>
                      <div className="text-center">
                        <button
                          onClick={() => {
                            setOrderAmount(report.Price_SUL);
                          }}
                          className="licence-buy-now cursor-pointer"
                          title="Buy Now"
                        >
                          {regionalText_1('buy_btn')}
                        </button>
                      </div>
                      <ul>
                        <li>{regionalText_1('descs.sul.l1')}</li>
                        <li>{regionalText_1('descs.sul.l2')}</li>
                        <li>{regionalText_1('descs.sul.l3')}</li>
                        <li>{regionalText_1('descs.sul.l4')}</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="license-box license-box-second h-full">
                      <p className="frequently-purchased">
                        {' '}
                        {regionalText_1('freq_sec')}
                      </p>

                      <p className="license-type flex justify-center items-center">
                        {regionalText_1('license_type.MUL')}
                      </p>
                      <p className="text-center text-sm text-slate-600 font-normal my-1">
                        ({regionalText_1('full_report')})
                      </p>
                      <p className="licence-price-revise">
                        <del>US$ 7,000</del>
                      </p>
                      <p className="licence-price">
                        US
                        <FaDollarSign className="-mt-1 inline" />{' '}
                        {report.Price_Multi.toLocaleString()}
                      </p>
                      <p className="licence-price-text">
                        {regionalText_1('price_in_words.prc_3')}
                      </p>
                      <div className="text-center">
                        <button
                          onClick={() => {
                            setOrderAmount(report.Price_Multi);
                          }}
                          className="licence-buy-now cursor-pointer"
                          title="Buy Now"
                        >
                          {regionalText_1('buy_btn')}
                        </button>
                      </div>
                      <ul>
                        <li>{regionalText_1('descs.mul.l1')}</li>
                        <li>{regionalText_1('descs.mul.l2')}</li>
                        <li>{regionalText_1('descs.mul.l3')}</li>
                        <li>{regionalText_1('descs.mul.l4')}</li>
                        <li>{regionalText_1('descs.mul.l5')}</li>
                        <li>{regionalText_1('descs.mul.l6')}</li>
                        <li>{regionalText_1('descs.mul.l7')}</li>
                        <li>{regionalText_1('descs.mul.l8')}</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <div className="license-box license-box-last h-full ">
                      <p className="license-type flex justify-center items-center">
                        {regionalText_1('license_type.CUL')}
                      </p>
                      <p className="text-center text-sm text-slate-600 font-normal my-1">
                        ({regionalText_1('full_report')})
                      </p>
                      <p className="licence-price-revise">
                        <del>US$ 10,000</del>
                      </p>
                      <p className="licence-price">
                        US
                        <FaDollarSign className="-mt-1 inline" />{' '}
                        {report.Price_CUL.toLocaleString()}
                      </p>
                      <p className="licence-price-text">
                        {regionalText_1('price_in_words.prc_4')}
                      </p>
                      <div className="text-center">
                        <button
                          onClick={() => {
                            setOrderAmount(report.Price_CUL);
                          }}
                          className="licence-buy-now cursor-pointer"
                          title="Buy Now"
                        >
                          {regionalText_1('buy_btn')}
                        </button>
                      </div>
                      <ul>
                        <li>{regionalText_1('descs.cul.l1')}</li>
                        <li>{regionalText_1('descs.cul.l2')}</li>
                        <li>{regionalText_1('descs.cul.l3')}</li>
                        <li>{regionalText_1('descs.cul.l4')}</li>
                        <li>{regionalText_1('descs.cul.l5')}</li>
                        <li>{regionalText_1('descs.cul.l6')}</li>
                        <li>{regionalText_1('descs.cul.l7')}</li>
                        <li>{regionalText_1('descs.cul.l8')}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };

  const SecondSection = () => {
    return (
      <div className="p-2 lg:p-8 lg:pt-2 buyNow-form h-full relative">
        <div className="container-mobile lg:container mx-auto grid grid-cols-1 lg:grid-cols-5 space-y-2 ">
          <div className="w-full lg:w-5/6 col-span-1 lg:col-start-1 lg:col-end-4 pt-2">
            <BuyNowForm
              orderAmount={orderAmount}
              reportId={report?.newsId}
              countryList={countryList}
            />
          </div>
          <div className="col-span-1 lg:col-span-2 lg:col-start-4">
            <div className="buynow-ordersummery shadow-2xl p-2 rounded-md lg:-mx-6 bg-gray-50 mb-5">
              <h1 className="title">{regionalText_2('summary_sec.heading')}</h1>
              <div className="h-px border border-dashed" />
              <h3 className="font-bold my-2 text-sm">
                {regionalText_2('summary_sec.title')}
              </h3>
              <h4 className="font-medium text-md px-2">
                {report?.keyword} {regionalText_2('summary_sec.keyword_sec')} (
                {report?.studyperiod})
              </h4>
              <div className="report-summeryBox my-2">
                <ul className="summeryList">
                  <li className="items-center">
                    <p className="font-normal">
                      {regionalText_2('summary_sec.format')}:
                    </p>
                    <div className="flex flex-row">
                      <Image
                        src={ppt_icon}
                        alt="ppt_icon.png"
                        className="p-1"
                        height={30}
                        width={30}
                      />
                      <Image
                        src={xcel_icon}
                        alt="xcel_icon.png"
                        className="p-1"
                        height={30}
                        width={30}
                      />
                      <Image
                        src={pdf_icon}
                        alt="pdf_icon.png"
                        className="p-1"
                        height={30}
                        width={30}
                      />
                    </div>
                  </li>
                  <li className="items-center">
                    <p className="font-normal">
                      {regionalText_2('summary_sec.nop')}:
                    </p>{' '}
                    <span>{report?.No_Pages}</span>
                  </li>
                </ul>
              </div>
              <hr />
              <div className="card ">
                <div className="card-body">
                  <LicenceTypes
                    licenceType={licenceType}
                    orderAmount={orderAmount}
                  />
                </div>
              </div>
            </div>
            <PaymentMethods regionalText={regionalText_2('payments')} />
            <BuyNowCredibility
              regionalText={regionalText_2('credibility_certification')}
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-between w-full mt-6">
          <div className="text-center space-y-2 mt-5">
            <h2 className="font-bold text-2xl text-blue-900">
              {regionalText_2('clientel.title')}
            </h2>
            <p className="text-md font-normal w-4/5 mx-auto">
              {regionalText_2('clientel.desc')}
            </p>
            <button className="bg-blue-900 p-3 outline-2 outline-offset-1 text-white rounded-lg">
              {regionalText_2('clientel.btn')}
            </button>
          </div>
          <div>
            <Image
              src={Clientel}
              alt="Existing Clientel"
              width={900}
              height={'auto'}
              className="p-5"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="content-wrapper">
      <div className="w-full mx-auto">
        <div className="buyNow-wrapper">
          {orderAmount === '' ? <FirstSection /> : <SecondSection />}
        </div>
      </div>
    </div>
  );
}
